import { useEffect } from "react";
import PropTypes from "prop-types";
import AlertMessage from "app/components/ui/AlertMessage/AlertMessage";
import { ALERT_TYPE, BRANDS, CABINS } from "app/constants";
import { FormattedMessage } from "react-intl";
import { useAnalytics } from "app/utils/analytics/useAnalytics";

export const shouldShowPremiumEconomyWarning = ({ hasCabins, brand, cabinCode }) =>
	hasCabins && brand === BRANDS.EK && cabinCode === CABINS.PREMIUM;

const PremiumEconomyWarning = ({ cabinLabel }) => {
	const { track } = useAnalytics();

	// Deferred + cancelable: a sibling correction (see CabinFallbackCorrection) can mount and
	// immediately unmount this component before paint. Without the delay, this still tracks a
	// "displayed" event for a warning the user never actually saw.
	useEffect(() => {
		const timeoutId = setTimeout(() => {
			track("cabin_premium_economy_warning_displayed", { cabinCode: CABINS.PREMIUM });
		}, 0);

		return () => clearTimeout(timeoutId);
	}, []);

	return (
		<div className="search-form__cabin-warning">
			<AlertMessage
				alertType={ALERT_TYPE.INFO}
				message={
					<FormattedMessage
						id="sdp.search.cabin.premium.economy.warning"
						values={{ cabinLabel }}
					/>
				}
			/>
		</div>
	);
};

PremiumEconomyWarning.propTypes = {
	cabinLabel: PropTypes.string,
};

export default PremiumEconomyWarning;
